"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldErrorContainer = exports.FieldTopline = exports.FieldRoot = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: baseline;\n  * {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// prettier-ignore
var FieldRoot = _styledComponents.default.div(_templateObject());

exports.FieldRoot = FieldRoot;

var FieldTopline = _styledComponents.default.div(_templateObject2());

exports.FieldTopline = FieldTopline;

var FieldErrorContainer = _styledComponents.default.div(_templateObject3());

exports.FieldErrorContainer = FieldErrorContainer;